import React from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
interface DeleteBridgeItemDialogProps {
  open: boolean;
  componentName: string;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}
const DeleteBridgeItemDialog: React.FC<DeleteBridgeItemDialogProps> = ({
  open,
  componentName,
  onClose,
  onConfirm
}) => {
  const [isDeleting, setIsDeleting] = React.useState(false);
  const handleConfirm = async () => {
    setIsDeleting(true);
    try {
      await onConfirm();
    } catch (error) {
      console.error("Error deleting bridge item:", error);
    } finally {
      setIsDeleting(false);
      onClose();
    }
  };
  return <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="bg-white border-primary/20 text-black">
        <DialogTitle className="text-black">Delete Bridge Component</DialogTitle>
        <DialogDescription className="text-black">
          Are you sure you want to delete "{componentName}"? This action cannot be undone.
        </DialogDescription>
        
        <DialogFooter>
          <Button type="button" variant="outline" onClick={onClose} className="text-black">
            Cancel
          </Button>
          <Button type="button" onClick={handleConfirm} disabled={isDeleting} className="bg-red-600 hover:bg-red-700 text-white">
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>;
};
export default DeleteBridgeItemDialog;